import React from "react";

const Badge: React.FC<{ customClass?: string; label: string }> = ({
  customClass,
  label,
}) => {
  return (
    <span
      className={`${customClass} bg-primary text-white text-[8px] font-medium me-2 px-2.5 py-0.5 rounded md:text-xs`}
    >
      {label}
    </span>
  );
};

export default Badge;
